export const growthTechReitId = '26';
export const intervalFundReitIds = ['24', '25'];
export const ipoReitId = '6';
export const ofundReitId = '10';
export const mergedEfundReitIds = ['7', '9'];
export const fundriseEfundReitId = '8';
